

import { Link } from 'react-router-dom';

import NavBarItems from './navBarItems';
// import Chart from './Chart';
// import Deposits from './Deposits';
// import Orders from './Orders';

import { Logo } from '../../logo';
import Main from '../main';



import { Navbar, NavbarSpacer } from '../../catalyst/navbar';
import {
  Sidebar,
  SidebarFooter,
  SidebarHeader
} from '../../catalyst/sidebar';
import { SidebarLayout } from '../../catalyst/sidebar-layout';
import config from '../../config';



export default function NavBar() {


  return (
    <>

      <SidebarLayout
        navbar={
          <Navbar>
            <NavbarSpacer />

            {/* {mobile top toolbar} */}

          </Navbar>
        }
        sidebar={
          <Sidebar>
            <SidebarHeader>

              <Link to={config.appUrl}>
                <Logo className="h-6 text-zinc-950 dark:text-white forced-colors:text-[CanvasText]" />
              </Link>
              {/* <SidebarSection className="max-lg:hidden">
                <SidebarItem href="/search">
                  <DocumentMagnifyingGlassIcon />
                  <SidebarLabel>Explore</SidebarLabel>
                </SidebarItem>
              </SidebarSection> */}
            </SidebarHeader>

            <NavBarItems></NavBarItems>

            <SidebarFooter className="max-lg:hidden">
            </SidebarFooter>
          </Sidebar>
        }
      >
        {/* The page content */}

        <Main />

      </SidebarLayout>
    </>
  );
}